// extracted by mini-css-extract-plugin
module.exports = {"rightImg":"RightImg-module--right-img--1FgK2","content":"RightImg-module--content--qLDsg","img":"RightImg-module--img--WWE8E"};